// extracted by mini-css-extract-plugin
export default {"container":"b81QnI","label":"g6HYch","tooltip":"jLMHix"};